import { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import classNames from "classnames";
import styles from "./style.module.scss";
import CustomInput from "shared/components/common/customInput";
import CustomButton from "shared/components/common/customButton";
import { toastMessage } from "shared/components/common/toast";
import { UpdatePasswordService } from "shared/services/settings";

const ChangePassword = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const validationSchema = Yup.object({
    currentPassword: Yup.string().required("Current password is required"),
    newPassword: Yup.string().required("New password is required"),
  });

  const formik = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
    },
    validationSchema,
    onSubmit: async (values) => {
      try {
        setLoading(true);
        await UpdatePasswordService(values.currentPassword, values.newPassword);
        toastMessage("success", "Password updated successfully");
        formik.resetForm();
      } catch (error) {
        toastMessage("error", "Failed to update password. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div>
      <h1 className="font-medium">Update Password</h1>
      <div className={classNames(styles.sectionContainer, "my-4")}>
        <form
          onSubmit={formik.handleSubmit}
          className={classNames(styles.body)}
        >
          <div>
            <CustomInput
              label="Current Password"
              placeholder="Enter Current Password"
              name="currentPassword"
              isPassword
              type="password"
              value={formik.values.currentPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.currentPassword && formik.errors.currentPassword
                  ? formik.errors.currentPassword
                  : ""
              }
            />
          </div>
          <div>
            <CustomInput
              label="New Password"
              placeholder="Enter New Password"
              name="newPassword"
              isPassword
              type="password"
              value={formik.values.newPassword}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={
                formik.touched.newPassword && formik.errors.newPassword
                  ? formik.errors.newPassword
                  : ""
              }
            />
          </div>

          <div className="flex justify-end mt-3">
            <CustomButton loading={loading} type="submit" title="Update" />
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;
